module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


//////////////////
// WEBPACK FOOTER
// ./~/jszip/~/core-js/library/modules/_is-object.js
// module id = 20
// module chunks = 0